import { Transform, Type } from "class-transformer";
import ResponseEntity, { InputEntity, RequestEntity, toEnum } from "../../..";
import {
  IsInt,
  IsEnum,
  ValidateIf,
  ValidateNested,
  IsArray,
  IsString,
  IsBoolean,
  IsNumber,
  IsDate,
} from "class-validator";
import OutputLc from "../../../lc";
import TransmedRegistrationField, {
  TransmedRegistrationFieldInput,
} from "./field";
import PrivateUser from "../../../user";

export enum TransmedRegistrationStage {
  "incomplete" = "incomplete",
  "submitted" = "submitted",
  "valid" = "valid",
  "rejected" = "rejected",
  "returned" = "returned",
  "accepted" = "accepted",
  "chosing" = "chosing",
  "confirmed" = "confirmed",
  "distributed" = "distributed",
  "no_place" = "no_place",
  "revoked" = "revoked",
}

export default class TransmedRegistration extends ResponseEntity {
  @IsInt() public readonly id!: number;
  @Transform(toEnum(TransmedRegistrationStage))
  @IsEnum(TransmedRegistrationStage, {
    message: "invalid OutputTransmedRegistrationStage",
  })
  public readonly stage!: TransmedRegistrationStage;

  @ValidateIf((obj) => obj.preferred_lc !== null)
  @Type(() => OutputLc)
  @ValidateNested()
  public readonly preferred_lc!: OutputLc | null;

  @IsBoolean() public readonly preferred_lc_accomodation!: boolean;

  @ValidateIf((obj) => obj.hierarchy !== null)
  @IsInt()
  public readonly hierarchy!: number | null;

  @ValidateIf((obj) => obj.batch !== null)
  @IsInt()
  public readonly batch!: number | null;

  @IsBoolean() public readonly passed!: boolean;

  @ValidateIf((obj) => obj.confirmed_lc !== null)
  @Type(() => OutputLc)
  @ValidateNested()
  public readonly confirmed_lc!: OutputLc | null;
  @IsBoolean() public readonly confirmed_lc_accomodation!: boolean;

  @ValidateIf((obj) => obj.question !== null)
  @IsString()
  public readonly question!: string | null;

  @ValidateIf((obj) => obj.answer !== null)
  @IsString()
  public readonly answer!: string | null;

  @ValidateIf((obj) => obj.rejection_message !== null)
  @IsString()
  public readonly rejection_message!: string | null;

  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => TransmedRegistrationField)
  public readonly fields!: TransmedRegistrationField[];

  @ValidateIf((obj) => obj.points !== null)
  @IsNumber()
  public readonly points!: number | null;

  @ValidateIf((obj) => obj.payment_proof !== null)
  @IsString()
  public readonly payment_proof!: string | null;

  @ValidateIf((obj) => obj.payment_proof_deadline !== null)
  @Type(() => Date)
  @IsDate()
  public readonly payment_proof_deadline!: Date | null;

  @IsBoolean() public readonly payment_proof_checked!: boolean;

  @ValidateIf((obj) => obj.participation_proof_1 !== null)
  @IsString()
  public readonly participation_proof_1!: string | null;

  @ValidateIf((obj) => obj.participation_proof_2 !== null)
  @IsString()
  public readonly participation_proof_2!: string | null;

  @ValidateIf((obj) => obj.participation_proof_3 !== null)
  @IsString()
  public readonly participation_proof_3!: string | null;

  @ValidateIf((obj) => obj.participation_proof_4 !== null)
  @IsString()
  public readonly participation_proof_4!: string | null;

  @ValidateIf((obj) => obj.participation_proof_5 !== null)
  @IsString()
  public readonly participation_proof_5!: string | null;

  @ValidateIf((obj) => obj.certificate_text !== null)
  @IsString()
  public readonly certificate_text!: string | null;

  @ValidateIf((obj) => obj.review !== null)
  @IsString()
  public readonly review!: string | null;

  @ValidateIf((obj) => obj.participation_proof_message !== null)
  @IsString()
  public readonly participation_proof_message!: string | null;

  @ValidateIf((obj) => obj.certificate !== null)
  @IsString()
  public readonly certificate!: string | null;

  @IsBoolean() public readonly participation_proof_checked!: boolean;
  @IsBoolean() public readonly review_checked!: boolean;
}

export class PublicTransmedRegistration extends ResponseEntity {
  @IsInt() public readonly id!: number;
  @Transform(toEnum(TransmedRegistrationStage))
  @IsEnum(TransmedRegistrationStage, {
    message: "invalid OutputTransmedRegistrationStage",
  })
  public readonly stage!: TransmedRegistrationStage;

  @Type(() => PrivateUser)
  @ValidateNested()
  public readonly user!: PrivateUser;

  @ValidateIf((obj) => obj.preferred_lc !== null)
  @IsString()
  public readonly preferred_lc!: string | null;
  @IsBoolean()
  public readonly preferred_lc_accomodation!: boolean;

  @ValidateIf((obj) => obj.confirmed_lc !== null)
  @Type(() => OutputLc)
  @ValidateNested()
  public readonly confirmed_lc!: OutputLc | null;
  @IsBoolean()
  public readonly confirmed_lc_accomodation!: boolean;

  @ValidateIf((obj) => obj.question !== null)
  @IsString()
  public readonly question!: string | null;

  @ValidateIf((obj) => obj.answer !== null)
  @IsString()
  public readonly answer!: string | null;

  @ValidateIf((obj) => obj.rejection_message !== null)
  @IsString()
  public readonly rejection_message!: string | null;

  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => TransmedRegistrationField)
  public readonly fields!: TransmedRegistrationField[];

  @ValidateIf((obj) => obj.points !== null)
  @IsNumber()
  public readonly points!: number | null;

  @ValidateIf((obj) => obj.payment_proof !== null)
  @IsString()
  public readonly payment_proof!: string | null;

  @ValidateIf((obj) => obj.payment_proof_deadline !== null)
  @Type(() => Date)
  @IsDate()
  public readonly payment_proof_deadline!: Date | null;

  @ValidateIf((obj) => obj.payment_proof_validator !== null)
  @Type(() => PrivateUser)
  @ValidateNested()
  public readonly payment_proof_validator!: PrivateUser | null;

  @ValidateIf((obj) => obj.participation_proof_1 !== null)
  @IsString()
  public readonly participation_proof_1!: string | null;

  @ValidateIf((obj) => obj.participation_proof_2 !== null)
  @IsString()
  public readonly participation_proof_2!: string | null;

  @ValidateIf((obj) => obj.participation_proof_3 !== null)
  @IsString()
  public readonly participation_proof_3!: string | null;

  @ValidateIf((obj) => obj.participation_proof_4 !== null)
  @IsString()
  public readonly participation_proof_4!: string | null;

  @ValidateIf((obj) => obj.participation_proof_5 !== null)
  @IsString()
  public readonly participation_proof_5!: string | null;

  @ValidateIf((obj) => obj.certificate_text !== null)
  @IsString()
  public readonly certificate_text!: string | null;

  @ValidateIf((obj) => obj.review !== null)
  @IsString()
  public readonly review!: string | null;

  @ValidateIf((obj) => obj.participation_proof_message !== null)
  @IsString()
  public readonly participation_proof_message!: string | null;

  @ValidateIf((obj) => obj.certificate !== null)
  @IsString()
  public readonly certificate!: string | null;

  @ValidateIf((obj) => obj.participation_proof_validator !== null)
  @Type(() => PrivateUser)
  @ValidateNested()
  public readonly participation_proof_validator!: PrivateUser | null;

  @ValidateIf((obj) => obj.review_validator !== null)
  @Type(() => PrivateUser)
  @ValidateNested()
  public readonly review_validator!: PrivateUser | null;
}

export class TransmedRegistrationFieldsInput extends InputEntity {
  public constructor(public fields: TransmedRegistrationFieldInput[]) {
    super();
  }
}

export class TransmedRegistrationLcInput extends InputEntity {
  public constructor(
    public preferred_lc: string,
    public preferred_lc_accomodation: boolean
  ) {
    super();
  }
}

export class TransmedRegistrationSubmitInput extends InputEntity {
  public constructor(public coordinator: boolean = false) {
    super();
  }
}

export class PutTransmedRegistration extends RequestEntity {
  public constructor(public id: number) {
    super();
  }
}